import { useGetSpacePrices } from '@cocoonspace/sdk-js/domains/availabilities/availabilities'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { fr } from 'date-fns/locale'
import { useTranslation } from 'next-i18next'
import { memo } from 'react'
import { Calendar, type CalendarProps } from '~/components/ui/calendar'
import CalendarDayWithPrice from '~/domains/booking/components/atoms/calendar-day-with-price'

export const SpacePricesCalendar = memo(
	({
		spaceId,
		maxDate,
		...props
	}: CalendarProps & {
		spaceId: string
		maxDate: string
	}) => {
		const { i18n } = useTranslation()

		const { data: calendarPrices } = useGetSpacePrices(spaceId, { to: maxDate })

		return (
			<Calendar
				locale={{ fr }[i18n.language]}
				disableNavigation
				classNames={{
					table: 'mx-0 w-full mt-2',
					button:
						'!text-sm rounded-full h-[45px] w-[45px] flex items-center justify-center cursor-pointer',
					head_cell: 'text-sm h-[30px] !w-[30px] font-normal opacity-50 p-1',
					cell: 'p-[1px] h-[50px] w-[50px]',
					month: 'px-4',
				}}
				toDate={dateTimeUtils(maxDate).toDate()}
				numberOfMonths={13}
				{...props}
				components={{
					DayContent: ({ date }) => (
						<CalendarDayWithPrice
							date={date}
							calendarPrices={calendarPrices?.data || []}
						/>
					),
					...(props.components || {}),
				}}
			/>
		)
	},
)
